import PropTypes from 'prop-types';
import React from 'react';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import Label from 'components/Label/Label';
import styles from '../BrowseFilter.module.scss';

const FilterHeader = ({
  expanded,
  setExpanded,
  numberOfFilters,
  roleTerm,
  skillTerm,
  roleSelected,
  skillSelected,
}) => {
  // Only show the title until the user selects a role or skill
  const showTitle = !roleSelected && !skillSelected;

  const numberOfExtraFilters = numberOfFilters - 1;
  const showNumberOfExtraFilters = numberOfExtraFilters > 0;
  const filtersString = `+${numberOfExtraFilters} filter${
    numberOfExtraFilters > 1 ? 's' : ''
  }`;

  return (
    <div className={styles.filterHeader}>
      <SvgIcon
        className={`${styles.chevron} ${expanded ? styles.up : ''}`}
        icon="chevron-down"
        size="18"
      />
      <div style={{ display: 'flex' }} onClick={setExpanded}>
        {showTitle ? (
          <h2>Filter results:</h2>
        ) : (
          <div style={{ display: 'flex' }}>
            <Label className={styles.statusLabel}>
              <strong>{roleTerm || skillTerm}</strong>
            </Label>
            {showNumberOfExtraFilters && (
              <span className={styles.extraFilters}>{filtersString}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

FilterHeader.propTypes = {
  roleSelected: PropTypes.bool,
  skillSelected: PropTypes.bool,
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func,
  numberOfFilters: PropTypes.number,
  roleTerm: PropTypes.string,
  skillTerm: PropTypes.string,
};

export default FilterHeader;
